// File: /src/contexts/DashboardIndicatorsContext.js

import { createContext, useContext } from 'react';

const DashboardIndicatorsContext = createContext(undefined);

export const DashboardIndicatorsProvider = ({ value, children }) => (
	<DashboardIndicatorsContext.Provider value={value}>
		{children}
	</DashboardIndicatorsContext.Provider>
);

export const useDashboardIndicators = () => {
	const context = useContext(DashboardIndicatorsContext);
	if (context === undefined) {
		throw new Error(
			'useDashboardIndicators deve ser usado dentro de um DashboardIndicatorsProvider',
		);
	}
	return context;
};

export default DashboardIndicatorsContext;
